import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ResponsiveService } from '../../services/responsive.service';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { ApiQuery } from '../../web-services/api/api.query';
import { ApiStore } from '../../web-services/api/api.store';
import { LOCAL_STORAGE_KEYS } from '../../constants';
import { App } from '@capacitor/app';

@Component({
  selector: 'app-logout',
  imports: [FormsModule],
  templateUrl: './logout.html',
  styleUrl: './logout.scss',
})
export class Logout {
  isMobile: Boolean;
	userEmail:string="";
	phone:string="";
	version_number: String;

  constructor(private responsiveService: ResponsiveService,
    private router: Router, private apiStore:ApiStore,private apiQuery:ApiQuery) {
		this.version_number = environment.appVersion;
	 }

  ngOnInit() {
    this.onResize();
	this.responsiveService.checkWidth();
	this.apiQuery.user$.subscribe(user => {
		if (!user) {
			return;
		}		
		this.phone = user["user_phone_number"];
		this.userEmail = user["user_email_address"];
	});

	App.addListener('backButton', data => {
		window.history.back();
	});
  }

  
	onResize() {
		this.responsiveService.getMobileStatus().subscribe(isMobile => {
		  this.isMobile = isMobile;
		});
  }
  
  logout() {
		this.apiStore.update({ 
			allFilteredDailyWorkPlan: [],
			filteredDailyWorkPlan: [],
			allFilteredBasicBins: [],
			filteredBasicBins: [],
			allCollectionsKpis: [],
			collectionsKpis: [],
			collectionsStatsInCollections: [],
			allCollectionsStats: [],
			collectionsStats: [],
			allRefillsKpis: [],
			refillsKpis: [],
			allRefillsStats: [],
			refillsStats: [],
			userEventsByType: [],
			collectionVolume: [],
			exceptionsReports: [],
			allDailyWorkPlanCalanderData: [],
			dailyWorkPlanCalanderData: [],
			allWorkPlanScheduler: [],
			workPlanScheduler: [],
			allSitesListData: [],
			sitesListData: []
		});
		//document.location.href="/";
		this.router.navigate(['/login']);
		localStorage.removeItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN);
		localStorage.removeItem(LOCAL_STORAGE_KEYS.USER);
	}
}
